/*
 * PhotoBooth
 * Description:
 * Module for managing booth data
 *
 * Purpose: This module contains all the stuff needed to manage Photobooth
 * 
 * @authors: Chiran Doshi and Elton Jain
 */

define('PhotoBooth',['jquery', 'DataList', 'UI', 'Config', 'JSTemplate', 'Helper','Auth','User'], function($, DataList, UI, Config, template, Helper, Auth, User) {
	'use strict';

	var o,
		langs = Config.get('lang'),
		defaults = {
			boothApi: '/ajax/booth/get', // Api to fetch data from
			global: 1, // 1 for global and 0 for local
			elLazyButtonId: 'btnLoadMoreBooths', // ID of load more button
			boothId: null,
			elBoothContainer: 'boothContainer',
			single: false
		},
		CURRENT_ROUTE = Config.get('page.route'),

		autoscroll,

		commentValidationRules = {
			message: {
				presence: {
					message: '^' + langs.err_c_blank
				}
			}
		},
		limitPhotoboothText = 140,

		dataList,
		dataList1,
		dataList2,
		dataCommentList,

		_showLikePopup = function(data) {

            var html = template('tplUserListContainer', 
                {
                    page: 1, 
                    parentContainerId: 'like-list-container',
                    ulContainerId: 'like-list',
                    loadMoreId: 'loadMoreUsers'
                });

            UI.$b.append(html);

            require(['DataList','History'], function(DataList, History) {
                var loadmore = true;

                dataList2 = new DataList(),
                    

                dataList2.init({
                    containerId: 'like-list',
                    template: 'tplUserInvite',
                    useApi: true,
                    api: '/ajax/booth/like/list',
                    apiData: data,
                    customFuseField: 'users',
                    lazyLoad: true,
                    elLazyButtonId: 'loadMoreUsers',
                    limitKey: 'user_limit',
                    onfetchCallback: function(results, o) {
                        if(o.customFuseField) {
                            data = results.response[o.customFuseField];
                        } else {
                            data = results.response;
                        }
                        if(data.length === 10) {
                            $('#' + o.elLazyButtonId).removeClass('hidden');
                        } else {
                            $('#' + o.elLazyButtonId).addClass('hidden');
                        }
                    }
                });

                History.pushState({
                    url: window.location.pathname + '',
                    popupId: 'like-list-container'
                });
                UI.noscroll();
            });
        },

		_fetchBoothData = function() {

			var apiData = {
				global: 1
			};

			dataList = new DataList();

			if(o.boothId) {
				apiData.boothId = o.boothId;
			} else {
				apiData.page = 1;
			}

			if(o.hashtag) {
				apiData.hashtag = o.hashtag;
			}

			if(o.commentId) {
				apiData.commentId = o.commentId;
			}

			if(o.single) {
				autoscroll = false;
			} else {
				autoscroll = true;
			}

			apiData.initializedTime = Math.round(new Date().getTime()/1000);

			dataList.init({
				containerId: o.elBoothContainer,
                template: 'tplBoothList',
                useApi: true,
                api: o.boothApi,
                lazyLoad: true,
                elLazyButtonId: o.elLazyButtonId,
                apiData: apiData,
                showNoMore: true,
                modules: {
                	Helper: Helper
                },
                autoscroll: autoscroll
			});
		},
		commonPost = function(api, apiData, callback) {
			$.post(api, apiData,function(response) {
				if(callback) {
					callback(response);
				}
			});
		},

		/**
		 * _getItem fetches required booth information from array
		 */

		_getItem = function(allItems, id) {

			for(var i = 0;i < allItems.length;i++) {
				if(allItems[i].booth.id == id) return allItems[i];
			}
			return false;
		},

		/**
		 * _postComment posts the comment
		 */
		
		_postComment = function(data,$form,boothId,user,item,allComments) {
			$.ajax({
            	url: '/ajax/booth/comment',
            	data: data,
            	type: 'POST',
            	success: function(results) {

            		if(results.status == true) {

            			var booth = '#booth-id-' + boothId,
            				chatbubble = '',
            				commentList = '',
            				html;

            			$form.removeClass('loading');

            			require(['Mixpanel'],function(MixPanel) {
							MixPanel.hit('user_event', {
								'event': 'PT Photo Comment',
                    			'booth_id': boothId,
                    			'user':user.fullname,
                    			'user_id':user.id 

                			});
						});

            			var $viewport = $('#boothDetailContainer');

            			item.comments.push(results.response.comments[0]);
            			item.more_comment_count++;
            			allComments.push(results.response.comments[0]);

            			$(booth).find('.booth-action-comment-view span').html(item.comments.length);
            			$(booth).find('.booth-action-comment-view').removeClass('hidden');

            			// Update Photobooth feed
            			chatbubble = $(booth).find('.btn-b-comment > .ion-ios-chatbubble-outline');

            			if(chatbubble.length > 0) {
            				chatbubble.removeClass('ion-ios-chatbubble-outline').addClass('ion-ios-chatbubble booth-comment-color');
            			}

            			commentList = $(booth).find('.booth-comment-list');

            			html = template('tplBoothCommentList', {
            					Helper: Helper,
            					not_popup: true,
            					data: results.response.comments
            				});

            			if(commentList.length > 0) {
            				$(commentList).html(html);

            			} else {

            				html = '<ul class="ui-list-sm booth-comment-list">' + html + '</ul>';

            				$(booth).find('.booth-info').after(html);
            			}


            			$viewport.animate({
                            scrollTop: $viewport.prop("scrollHeight")
                        }, 1000);

            			$('#boothCommentForm')[0].reset();

            			html = template('tplBoothCommentList', {
            				data: results.response.comments,
            				Helper: Helper
            			});

            			$('#boothCommentList').append(html);

            			$('#pt-stickers-container').removeClass('open');

            		}
            	}
            });

		},

		/**
		 * [_bindEvents binds all required events]
		 * Author: Chiran Doshi
		 *
		 */
		_bindEvents = function() {

			// Click of like button
			UI.$b.on('click','.btn-b-like', function(ev) {

				var user = Auth.getUser(), image;

				if(!user) {
					Auth.showLoginPopup();	
					return;
				}

				// if(Helper.getUserAgent().indexOf("iphone") > -1 || Helper.getUserAgent().indexOf("ipad") > -1) {
    //                 image = 'http://icons.iconarchive.com/icons/wineass/ios7-redesign/512/Appstore-icon.png';
    //             } else {
    //                 image = 'http://cdn.thedroidguy.com/wp-content/uploads/2015/12/Google-Play-Store-Icon.jpg';
    //             }


    //             Helper.showDialog({
    //             	heading: langs.photobooth_like_download_heading,
    //             	image: image,
    //             	buttonText: langs.photobooth_text_button,
    //                 href:'/dl',
    //                 extra_class:'btn-download-app'
    //             });

    //             return;
	
				var base = $(this),
					boothId = base.closest('.booth-item').data('id'),
					action = base.hasClass('active') ? 'unlike' : 'like',
					api = (action === 'unlike') ? '/ajax/booth/unlike' : '/ajax/booth/like',
					boothLikeInfo = (Config.get('page.route') == 'home') ? base.find('.itm-action-count') : $('#booth-like-' + boothId),
					boothLikeCount =  (Config.get('page.route') == 'home') ? boothLikeInfo : boothLikeInfo.find('.booth-like-count'),
					apiData = {boothId: boothId},
					likeCount = parseInt(boothLikeCount.html());


				base.toggleClass('active');

				commonPost(api, apiData, function(response) {
					if(response.status == true) {

						require(['Mixpanel'],function(MixPanel) {
							MixPanel.hit('user_event', {
								'event': 'PT Photo Like',
                    			'booth_id': boothId,
                    			'user':user.fullname,
                    			'user_id':user.id 

                			});
						});

						if (action === 'unlike') {
							likeCount--;
						} else {
							likeCount++;
						}

						likeCount === 0 ? boothLikeInfo.addClass('hidden') : boothLikeInfo.removeClass('hidden');

						boothLikeCount.html(likeCount);
						
					}
				});
			});	

			// on click of emoji button
			UI.$b.on('click','.btn-pt-sticker', function(ev) {

				$('#pt-stickers-container').toggleClass('open');

				if($('.pt-sticker').length === 0) {
					dataList1 = new DataList();

	                dataList1.init({
	                    containerId: 'pt-stickers-container',
	                    template: 'tplStickersList',
	                    useApi: true,
	                    api: '/ajax/stickers/get',
	                    apiData: {
	                    	page: 1
	                    },
	                    customFuseField: 'stickers',
	                    onfetchCallback: function(results, o) {
	                    	var data = results.response[o.customFuseField];
	                    	if(Bugsnag && !data) {
	                    		Bugsnag.notify("Photobooth stickers absent","Server did not send any stickers");
	                    	}
	                    }
	                });
				}

				//var html = template('tplStickersList');
				//UI.$b.append(html);
			});

			// On click of share button
			UI.$b.on('click','.btn-b-share', function(ev) {

				var url = $(this).closest('.booth-item').data('share-url');

				require(['Helper'], function (Helper) {
	                Helper.showInvitePopup({
	                	url: url,
                        btn_text: 'Share via',
                        type: 'share',
	                    message: langs.booth_share_text,
	                    content: 'photo'
	                });
	                if(UI.$header.is('.open')) {
	                    UI.$header.removeClass('open');
	                    $eleNavTrigger.removeClass('active');
	                }
            	});
			});

			// On click of like list
			UI.$b.on('click','.booth-like-info',function(ev) {
				if(!Auth.getUser()) {
					Auth.showLoginPopup();	
					return;
				}

				var base = $(ev.target),
					boothId = base.closest('.booth-item').data('id'),
					data = {
						page:1,
						boothId: boothId
					};

				_showLikePopup(data);


			});

			// On click of share button
			UI.$b.on('click','.btn-b-comment, .booth-action-comment-view, .btn-booth-more-comments', function(ev) {

				if(!Auth.getUser()) {
					Auth.showLoginPopup();	
					return;
				}

				var base = $(this),
					boothId = base.closest('.booth-item').data('id'),
					url = base.closest('.booth-item').data('url'),
					item = (CURRENT_ROUTE == 'home') ? window._gtap.data.fb[boothId] : _getItem(dataList.getData(), boothId),
					html = template('tplBoothList', {
						isDetailPage: true,
						popup: true,
						data: [item],
						Helper: Helper
					});

				UI.$b.append(html);
				UI.showBackButton();
				UI.noscroll();
				dataCommentList = new DataList();

				if(item.comments.length > 0) {
					
					dataCommentList.init({
						containerId: 'boothCommentList',
		                template: 'tplBoothCommentList',
		                useApi: true,
		                api: '/ajax/booth/comment/get',
		                lazyLoad: true,
		                elLazyButtonId: 'btnLoadMoreBoothComments',
		                apiData: {
		                	page: 1,
		                	boothId: item.booth.id
		                },
		                showNoMore: true,
		                customFuseField: 'comments',
		                append: false,
		                modules: {
		                	Helper: Helper
		                }
					});
				}

				require(['History'], function(History) {
					History.pushState({
	                    popupId: 'boothDetailContainer',
	                    isPage: true,
	                    removeEl: true,
	                    url: url,
	                    callback: function () {
	                        UI.showBackButton(false);
	                    }
                	});	
				});
				return false;
			});

			UI.$b.on('focus','.inp-answer-text', function(ev) {
				$('#pt-stickers-container').removeClass('open');
			});

			// on click of emoji button
			UI.$b.on('click','.pt-sticker', function(ev) {

				var user = Auth.getUser();

				if(!user) {
					Auth.showLoginPopup();	
					return;
				}

				var base = $(this),
					parentContainer = base.closest('.pb-sticky-foot'),
					boothId = parentContainer.find('input[name="boothId"]').val(),
					data = {
						message: base.data('message'),
						boothId: boothId
					},
					allItems = dataList.getData(),
	                item = (CURRENT_ROUTE == 'home') ? window._gtap.data.fb[boothId] : _getItem(allItems, boothId),
	                allComments = dataCommentList.getData();
	               
	            _postComment(data,$(),boothId,user,item,allComments);

			});		

			// On clicking submit button
			UI.$b.on('submit', '#boothCommentForm', function(ev) {

				var user = Auth.getUser();

				if(!user) {
					Auth.showLoginPopup();	
					return;
				}

				var that = $(this),
					allComments = dataCommentList.getData();

				require(['Validation'], function(Validation) {
					var $form = that,
						boothId = $form[0].boothId.value,
						validation = new Validation({
			                form: $form,
			                allConstraints: commentValidationRules
			            }),
			            data = $form.serialize();

			        if (validation.isValid() !== true) {
	                    return;
	                }

	                var allItems = (CURRENT_ROUTE == 'home') ? window._gtap.data.fb : dataList.getData(),
	                	item = (CURRENT_ROUTE == 'home') ? window._gtap.data.fb[boothId] : _getItem(allItems, boothId),
	                	submitBtn = that.find(':submit');

	                $form.addClass('loading');

	                _postComment(data,$form,boothId,user,item,allComments);

                	return false;
				});
            });

            // On clicking more options
			UI.$b.on('click', '.booth-info-parent .post-itm-option,.feed-post-itm-option', function(ev) {
				var base = $(this),
					type = base.data('type'),
					item;


					if(type === 'booth') {
						var boothId = base.closest('.booth-item').data('id'),
							allItems = (CURRENT_ROUTE == 'home') ? window._gtap.data.fb : dataList.getData(),
							item = (CURRENT_ROUTE == 'home') ? window._gtap.data.fb[boothId] : _getItem(dataList.getData(), boothId),
							actions = item.booth.actions,
							html = template('tplFeedActionPopup', {
								tmplData: actions,
								langs: langs
							}),
							apiData = {
								boothId: boothId,
								message: item.booth.message
							};
					} else {
						var boothCommentId = base.closest('.booth-comment-item').data('id'),
							allItems = dataCommentList.getData(),
							item = $.grep(allItems, function(e){ return e.id == boothCommentId; })[0],
							actions = item.actions,
							html = template('tplFeedActionPopup', {
								tmplData: actions,
								langs: langs
							}),
							apiData = {
								commentId: boothCommentId
							};
					}
					

				require(['modules/Feed/FeedAction'], function(FeedAction) {
					var fa = new FeedAction(type);
                    fa.showActionMenu(actions, apiData, base, '', type);
				});

			});	

			// On click of hashtag
			UI.$b.on('click','.booth-tag', function(ev) {

				var base = $(this);

				require(['Mixpanel'],function(MixPanel) {
					MixPanel.hit('click', {
            			'target': 'hashtag',
            			'value': base.text().substring(1)
        			}, function() {
                        window.location = base.attr('href');
                    });
				});

				return false;
			});

			// On double click of a pic
			var touchtime = 0;
			UI.$b.on('click','#boothContainer .booth-pic',function() {
				if(touchtime == 0) {
			        // Set first click
			        touchtime = new Date().getTime();
			    } else {
			        // Compare first click to this click and see if they occurred within double click threshold
			        if(((new Date().getTime())-touchtime) < 500) {
			        	touchtime = 0;

			        	var base = $(this),
							booth = base.closest('.booth-item'),
							btnLike = booth.find('.btn-b-like'),
							isLiked = btnLike.hasClass('active'),
							dblLike = base.find('.dbl-like');

						dblLike.fadeIn('fast').fadeOut('slow');

						if(isLiked) {
							return;
						} else {
							if(!Auth.getUser()) {
								Auth.showLoginPopup();
								return;	
							}
							btnLike.trigger('click');
						}

			        } else {
			            // Not a double click so set as a new first click
			            touchtime = new Date().getTime();
			        }
			    } 
			});

			UI.$b.on('click','#formPhotoWrap',function(ev) {

				var image = '';
				
                if(Helper.getUserAgent().indexOf("iphone") > -1 || Helper.getUserAgent().indexOf("ipad") > -1) {
                    image = 'http://icons.iconarchive.com/icons/wineass/ios7-redesign/512/Appstore-icon.png';
                } else {
                    image = 'http://cdn.thedroidguy.com/wp-content/uploads/2015/12/Google-Play-Store-Icon.jpg';
                }

				Helper.showDialog({
                    image: image,
                    heading: langs.photobooth_download_heading,
                    buttonText: langs.photobooth_text_button,
                    href:'/dl',
                    extra_class:'btn-download-app'
                });
			});

			UI.$b.on('click','.btn-download-app',function(ev) {

				var base = $(this);

				require(['Mixpanel'], function (MixPanel) {

                    MixPanel.hit('click', {
                        target: 'photobooth download app',
                        url: base.attr('href')
                    }, function() {
                        window.location = base.attr('href');
                    });


                });

                return false;
			});


			// On click of see more button
			UI.$b.on('click','.booth-info-parent .btn-expand, .feed-booth-post .btn-expand',function(ev) {
				var base = $(this),
					boothText = base.siblings('.hidden-booth-text').text() ? base.siblings('.hidden-booth-text').text() : base.parent().siblings('.hidden-booth-text').text();
				
				base.closest('.booth-text').html(Helper.parseTags(boothText));
			});

		},

		parseFeed = function() {
			var booths = window._gtap.data.fb,
				keys = Object.keys(booths);

			for(var i = 0;i < keys.length;i++) {
				var spaceIndex,
					item = booths[parseInt(keys[i])],
					boothMessage = item.booth.message;

				if(boothMessage.length < limitPhotoboothText) {
					$('#booth-id-' + item.booth.id + ' .partial-text').html(Helper.parseTags(item.booth.message));	
				} else {
					for(var j = limitPhotoboothText;j < boothMessage.length;j++) {
						if(boothMessage[j] === ' ' && j > limitPhotoboothText) {
							spaceIndex = j;
							break;
						}
					}

					$('#booth-id-' + item.booth.id + ' .partial-text').html(Helper.parseTags(item.booth.message.slice(0,spaceIndex)) + "<span class='btn-expand'>" + langs.see_more_q + "</span>");	
				}
			}
		},

		/**
		 * [init initializes Photobooth library]
		 * Author: Chiran Doshi
		 *
		 * @return {object} [description]
		 */
		init = function(options) {
			o = $.extend(defaults, options);

			// Change api depending on the request mode
            if (o.boothId) {
            	o.boothApi += '/single';
            } else if(o.hashtag) {
            	o.boothApi = '/ajax/booth/get/hashtag';
            }

       
            // Fetch required data
            if(Config.get('page.route') != 'home') {
            	_fetchBoothData();	
            }
			
			// Bind necessary events
			_bindEvents();

			User.init();
		};

	return {
		init: init,
		parseFeed: parseFeed
	}
});
